export enum ActivityStatus {
  LOGIN = 'LOGIN',
  CREATE = 'CREATE',
  RECOVERY = 'RECOVERY',
  DELETE = 'DELETE',
  SHARE = 'SHARE',
  UNSHARE = 'UNSHARE',
  VIEW = 'VIEW',
  RECOVERY_TOKEN = 'RECOVERY_TOKEN',
  SEND_CYPHER_VIA_SMS = 'SEND_CYPHER_VIA_SMS',
  SEND_CYPHER_VIA_EMAIL = 'SEND_CYPHER_VIA_EMAIL',
}
